<ng-container *transloco="let t">
    <div class="document-container">
        <div class="d-flex justify-content-center">
            <p class="document-title">{{t('personal.data.protection.notice.document.title')}}</p>
        </div>

        <div class="chapter mt-3">
            <p class="pt-2">
                {{t('personal.data.protection.notice.document.intro.1')}}
            </p>
            <p class="pt-2">
            {{t('personal.data.protection.notice.document.intro.2')}}
            </p>
            <p class="pt-2">
            {{t('personal.data.protection.notice.document.intro.3')}}
            </p>
            <p class="pt-2 teal fw-medium">
            {{t('personal.data.protection.notice.document.intro.4')}}
            </p>
            <p class="pt-2">
            {{t('personal.data.protection.notice.document.intro.5')}}
        </p>
        </div>


        <div class="chapter mt-3 pb-3">
<!--            STOTINKA I ORGANIZATOR KAO ZAJEDNIČKI VODITELJI OBRADE OSOBNIH PODATAKA-->
            <p class="title">{{t(translocoPrefix + '1.title')}}</p>

            <div class="sub-chapter">
                    <p class="title pt-4">{{t(translocoPrefix + '1.1.title')}}</p>
                    <div class="ps-4 pt-4">
                        <p class="title fst-italic">{{t(translocoPrefix + '1.1.1.title')}}</p>
                        <p >{{t(translocoPrefix + '1.1.1.content.1')}}</p>
                        <p class="pt-2 ps-4">{{t(translocoPrefix + '1.1.1.content.2')}}</p>
                        <p class="text-center">{{t(translocoPrefix + '1.1.1.content.3')}}</p>
                        <p class="ps-4">{{t(translocoPrefix + '1.1.1.content.4')}}</p>
                        <p class="pt-2">{{t(translocoPrefix + '1.1.1.content.5')}}</p>
                    </div>

                    <div class="ps-4 pt-4">
                        <p class="title fst-italic">{{t(translocoPrefix + '1.1.2.title')}}</p>
                        <p class="pt-2">{{t(translocoPrefix + '1.1.2.content.1')}}</p>
                        <p class="pt-2">{{t(translocoPrefix + '1.1.2.content.2')}}</p>
                    </div>

                    <div class="ps-4 pt-4">
                        <p class="title fst-italic">{{t(translocoPrefix + '1.1.3.title')}}</p>
                        <p class="pt-2">{{t(translocoPrefix + '1.1.3.content.1')}}</p>
                        <p class="pt-2">{{t(translocoPrefix + '1.1.3.content.2')}}</p>
                    </div>

                    <div class="ps-4 pt-3">
                        <p class="title fst-italic">{{t(translocoPrefix + '1.1.4.title')}}</p>
                        <p class="pt-2">{{t(translocoPrefix + '1.1.4.content.1')}}</p>
                        <p class="pt-2">{{t(translocoPrefix + '1.1.4.content.2')}}</p>
                        <p class="pt-2">{{t(translocoPrefix + '1.1.4.content.3')}}</p>
                    </div>
            </div>

            <div class="sub-chapter">
                <p class="title pt-4">{{t(translocoPrefix + '1.2.title')}}</p>
                <p class="pt-2">{{t(translocoPrefix + '1.2.content.1')}}</p>

<!--                1) Svrha: Registracija na Događaj putem Platforme:-->
                <div class="ps-4 pt-4">
                    <p class="title fst-italic">{{t(translocoPrefix + '1.2.1.title')}}</p>
                    <p>{{t(translocoPrefix + '1.2.1.content.1')}}</p>
                    <p class="title pt-3">{{t(translocoPrefix + '1.2.1.1.title')}}</p>
                    <div class="ps-2">
                        <ul>
                            <li>{{t(translocoPrefix + '1.2.1.1.content.1')}}</li>
                            <li>{{t(translocoPrefix + '1.2.1.1.content.2')}}</li>
                            <li>{{t(translocoPrefix + '1.2.1.1.content.3')}}</li>
                            <li>{{t(translocoPrefix + '1.2.1.1.content.4')}}</li>
                            <li>{{t(translocoPrefix + '1.2.1.1.content.5')}}</li>
                            <li>{{t(translocoPrefix + '1.2.1.1.content.6')}}</li>
                            <li>{{t(translocoPrefix + '1.2.1.1.content.7')}}</li>
                        </ul>
                        <p>{{t(translocoPrefix + '1.2.1.1.content.8')}}</p>
                    </div>

                    <p class="title pt-3">{{t(translocoPrefix + '1.2.1.2.title')}}</p>
                    <p>{{t(translocoPrefix + '1.2.1.2.content.1')}}</p>

                    <p class="title pt-3">{{t(translocoPrefix + '1.2.1.3.title')}}</p>
                    <p>{{t(translocoPrefix + '1.2.1.3.content.1')}}</p>

                    <p class="title pt-3">{{t(translocoPrefix + '1.2.1.4.title')}}</p>
                    <div class="ps-2">
                        <p class="teal">{{t(translocoPrefix + '1.2.1.4.content.1')}}</p>
                        <ul>
                            <li>{{t(translocoPrefix + '1.2.1.4.content.2')}}</li>
                            <li>{{t(translocoPrefix + '1.2.1.4.content.3')}}</li>
                            <li>{{t(translocoPrefix + '1.2.1.4.content.4')}}</li>
                            <li>{{t(translocoPrefix + '1.2.1.4.content.5')}}</li>
                        </ul>
                    </div>
                    <div class="ps-2">
                        <p class="teal">{{t(translocoPrefix + '1.2.1.4.content.6')}}</p>
                        <ul>
                            <li>{{t(translocoPrefix + '1.2.1.4.content.7')}}</li>
                            <li>{{t(translocoPrefix + '1.2.1.4.content.8')}}</li>
                        </ul>
                    </div>



                </div>

                <!--                    2) Svrha: Formiranje liste natjecatelja i objava liste na Platformi-->
                <div class="ps-4 pt-4">
                    <p class="title fst-italic">{{t(translocoPrefix + '1.2.2.title')}}</p>

                    <p class="title pt-3">{{t(translocoPrefix + '1.2.2.1.title')}}</p>
                    <p>{{t(translocoPrefix + '1.2.2.1.content.1')}}</p>

                    <p class="title pt-3">{{t(translocoPrefix + '1.2.2.2.title')}}</p>
                    <div class="ps-2">
                        <ul>
                            <li>{{t(translocoPrefix + '1.2.2.2.content.1')}}</li>
                            <li>{{t(translocoPrefix + '1.2.2.2.content.2')}}</li>
                        </ul>
                    </div>

                    <p class="title pt-3">{{t(translocoPrefix + '1.2.2.3.title')}}</p>
                    <p>{{t(translocoPrefix + '1.2.2.3.content.1')}}</p>

                    <p class="title pt-3">{{t(translocoPrefix + '1.2.2.4.title')}}</p>
                    <div class="ps-2">
                        <p class="teal">{{t(translocoPrefix + '1.2.2.4.content.1')}}</p>
                        <ul>
                            <li>{{t(translocoPrefix + '1.2.2.4.content.2')}}</li>
                            <li>{{t(translocoPrefix + '1.2.2.4.content.3')}}</li>
                            <li>{{t(translocoPrefix + '1.2.2.4.content.4')}}</li>
                        </ul>
                    </div>

                    <div class="ps-2">
                        <p class="teal">{{t(translocoPrefix + '1.2.2.4.content.6')}}</p>
                        <ul>
                            <li>{{t(translocoPrefix + '1.2.2.4.content.8')}}</li>
                            <li>{{t(translocoPrefix + '1.2.2.4.content.9')}}</li>
                            <li>{{t(translocoPrefix + '1.2.2.4.content.10')}}</li>
                        </ul>
                    </div>
                </div>



<!--                3)    Svrha: Obrada u svrhu plaćanja za sudjelovanja na Događaju, izdavanje računa te povrata uplate u slučaju otkaza-->
                <div class="ps-4 pt-4">
                    <p class="title fst-italic">{{t(translocoPrefix + '1.2.3.title')}}</p>
                    <p>{{t(translocoPrefix + '1.2.3.content.1')}}</p>

                    <p class="title pt-3">{{t(translocoPrefix + '1.2.3.1.title')}}</p>
                    <p>{{t(translocoPrefix + '1.2.3.1.content.1')}}</p>
                    <div class="ps-4">
                        <p class="teal fw-medium fst-italic pt-2">{{t(translocoPrefix + '1.2.3.1.1.title')}}</p>
                        <p>{{t(translocoPrefix + '1.2.3.1.1.content.1')}}</p>

                        <p class="teal fw-medium fst-italic pt-2">{{t(translocoPrefix + '1.2.3.1.2.title')}}</p>
                        <p>{{t(translocoPrefix + '1.2.3.1.2.content.1')}}</p>
                    </div>


                    <p class="title pt-3">{{t(translocoPrefix + '1.2.3.2.title')}}</p>
                    <p>{{t(translocoPrefix + '1.2.3.2.content.1')}}</p>
                    <p>{{t(translocoPrefix + '1.2.3.2.content.2')}}</p>

                    <div class="ps-4">
                        <p class="teal fw-medium fst-italic pt-2">{{t(translocoPrefix + '1.2.3.2.1.title')}}</p>
                        <p>{{t(translocoPrefix + '1.2.3.2.1.content.1')}}</p>
                    </div>


                    <p class="title pt-3">{{t(translocoPrefix + '1.2.3.3.title')}}</p>
                    <p>{{t(translocoPrefix + '1.2.3.3.content.1')}}</p>
                    <div class="ps-4">
                        <p class="teal fw-medium fst-italic pt-2">{{t(translocoPrefix + '1.2.3.3.1.title')}}</p>
                        <p>{{t(translocoPrefix + '1.2.3.3.1.content.1')}}</p>

                        <p class="teal fw-medium fst-italic pt-2">{{t(translocoPrefix + '1.2.3.3.2.title')}}</p>
                        <p>{{t(translocoPrefix + '1.2.3.3.2.content.1')}}</p>

                        <p class="teal fw-medium fst-italic pt-2">{{t(translocoPrefix + '1.2.3.3.3.title')}}</p>
                        <p>{{t(translocoPrefix + '1.2.3.3.3.content.1')}}</p>
                    </div>
                </div>



<!--                4) Svrha: Mjerenje rezultata Događaja te obrada pohranom rezultata mjerenja utrke u svrhu provjera točnosti izmjera u budućnosti ili u slučaju prigovora-->
                <div class="ps-4 pt-4">
                    <p class="title fst-italic">{{t(translocoPrefix + '1.2.4.title')}}</p>
                    <p>{{t(translocoPrefix + '1.2.4.content.1')}}</p>

                    <p class="title pt-3">{{t(translocoPrefix + '1.2.4.1.title')}}</p>
                    <p>{{t(translocoPrefix + '1.2.4.1.content.1')}}</p>


                    <p class="title pt-3">{{t(translocoPrefix + '1.2.4.2.title')}}</p>
                    <p>{{t(translocoPrefix + '1.2.4.2.content.1')}}</p>

                    <p class="title pt-3">{{t(translocoPrefix + '1.2.4.3.title')}}</p>
                    <p>{{t(translocoPrefix + '1.2.4.3.content.1')}}</p>

                    <p class="title pt-3">{{t(translocoPrefix + '1.2.4.4.title')}}</p>
                    <p>{{t(translocoPrefix + '1.2.4.4.content.1')}}</p>
                </div>


<!--                5) Svrha: Objava rezultata Sudionika Događaja na Platformi / arhiviranje s pristupom javnosti na Platformi kako bi Sudionici i budući sudionici mogli provjeriti dinamiku i ostale elemente posjećenosti Događaja /promoviranje posjećenosti Događaja-->
                <div class="ps-4 pt-4">
                    <p class="title fst-italic">{{t(translocoPrefix + '1.2.5.title')}}</p>

                    <p class="title pt-3">{{t(translocoPrefix + '1.2.5.1.title')}}</p>
                    <p>{{t(translocoPrefix + '1.2.5.1.content.1')}}</p>


                    <p class="title pt-3">{{t(translocoPrefix + '1.2.5.2.title')}}</p>
                    <ul>
                        <li><p>{{t(translocoPrefix + '1.2.5.2.content.1')}}</p></li>
                        <li><p>{{t(translocoPrefix + '1.2.5.2.content.2')}}</p></li>
                        <li><p>{{t(translocoPrefix + '1.2.5.2.content.3')}}</p></li>
                        <li><p>{{t(translocoPrefix + '1.2.5.2.content.4')}}</p></li>
                        <li><p>{{t(translocoPrefix + '1.2.5.2.content.5')}}</p></li>
                        <li><p>{{t(translocoPrefix + '1.2.5.2.content.6')}}</p></li>
                        <li><p>{{t(translocoPrefix + '1.2.5.2.content.7')}}</p></li>
                    </ul>
                    <p class="ps-4">{{t(translocoPrefix + '1.2.5.2.content.8')}}</p>

                    <p class="title pt-3">{{t(translocoPrefix + '1.2.5.3.title')}}</p>
                    <p>{{t(translocoPrefix + '1.2.5.3.content.1')}}</p>

                    <p class="title pt-3">{{t(translocoPrefix + '1.2.5.4.title')}}</p>
                    <p class="teal">{{t(translocoPrefix + '1.2.5.4.content.1')}}</p>

                    <ul>
                        <li><p>{{t(translocoPrefix + '1.2.5.4.content.2')}}</p></li>
                        <li><p>{{t(translocoPrefix + '1.2.5.4.content.3')}}</p></li>
                        <li><p>{{t(translocoPrefix + '1.2.5.4.content.4')}}</p></li>
                    </ul>

                    <p class="teal">{{t(translocoPrefix + '1.2.5.4.content.5')}}</p>
                    <ul>
                        <li><p>{{t(translocoPrefix + '1.2.5.4.content.6')}}</p></li>
                        <li><p>{{t(translocoPrefix + '1.2.5.4.content.7')}}</p></li>
                        <li><p>{{t(translocoPrefix + '1.2.5.4.content.8')}}</p></li>
                        <li><p>{{t(translocoPrefix + '1.2.5.4.content.9')}}</p></li>
                    </ul>

                </div>




<!--                6) Objava fotografija ili video zapisa na Platformi / drugim društvenim mrežama-->
                <div class="ps-4 pt-4">
                    <p class="title fst-italic">{{t(translocoPrefix + '1.2.6.title')}}</p>

                    <p class="title pt-3">{{t(translocoPrefix + '1.2.6.1.title')}}</p>
                    <p>{{t(translocoPrefix + '1.2.6.1.content.1')}}</p>


                    <p class="title pt-3">{{t(translocoPrefix + '1.2.6.2.title')}}</p>
                    <p>{{t(translocoPrefix + '1.2.6.2.content.1')}}</p>

                    <p class="title pt-3">{{t(translocoPrefix + '1.2.6.3.title')}}</p>
                    <p>{{t(translocoPrefix + '1.2.6.3.content.1')}}</p>

                    <p class="title pt-3">{{t(translocoPrefix + '1.2.6.4.title')}}</p>
                    <ul>
                        <li><p>{{t(translocoPrefix + '1.2.6.4.content.1')}}</p></li>
                        <li><p>{{t(translocoPrefix + '1.2.6.4.content.2')}}</p></li>
                        <li><p>{{t(translocoPrefix + '1.2.6.4.content.3')}}</p></li>
                    </ul>
                </div>



<!--               7) Statistike praćenja broja i kategorije prijavljenih Sudionika-->
                <div class="ps-4 pt-4">
                    <p class="title fst-italic">{{t(translocoPrefix + '1.2.7.title')}}</p>

                    <p class="title pt-3">{{t(translocoPrefix + '1.2.7.1.title')}}</p>
                    <p>{{t(translocoPrefix + '1.2.7.1.content.1')}}</p>


                    <p class="title pt-3">{{t(translocoPrefix + '1.2.7.2.title')}}</p>
                    <p>{{t(translocoPrefix + '1.2.7.2.content.1')}}</p>

                    <p class="title pt-3">{{t(translocoPrefix + '1.2.7.3.title')}}</p>
                    <p>{{t(translocoPrefix + '1.2.7.3.content.1')}}</p>
                </div>



<!--               8) Obrada podataka u svrhu slanja marketinškog materijala (poziva za Događaj koji se publicira putem Platforme), izravni marketing***-->
                <div class="ps-4 pt-4">
                    <p class="title fst-italic">{{t(translocoPrefix + '1.2.8.title')}}</p>
                    <p>{{t(translocoPrefix + '1.2.8.content.1')}}</p>

                    <p class="title pt-3">{{t(translocoPrefix + '1.2.8.1.title')}}</p>
                    <p>{{t(translocoPrefix + '1.2.8.1.content.1')}}</p>


                    <p class="title pt-3">{{t(translocoPrefix + '1.2.8.2.title')}}</p>
                    <p>{{t(translocoPrefix + '1.2.8.2.content.1')}}</p>

                    <p class="title pt-3">{{t(translocoPrefix + '1.2.8.3.title')}}</p>
                    <p>{{t(translocoPrefix + '1.2.8.3.content.1')}}</p>

                    <p class="title pt-3">{{t(translocoPrefix + '1.2.8.4.title')}}</p>
                    <p>{{t(translocoPrefix + '1.2.8.4.content.1')}}</p>
                </div>


<!--                Napomene-->
                <div class="ps-2 pt-4">
                    <p class="teal">{{t(translocoPrefix + '1.2.9.title')}}</p>
                    <p class="pt-2">{{t(translocoPrefix + '1.2.9.content.1')}}</p>
                    <p class="pt-2">{{t(translocoPrefix + '1.2.9.content.2')}}</p>
                    <p class="pt-2">{{t(translocoPrefix + '1.2.9.content.3')}}</p>
                    <p class="pt-2">{{t(translocoPrefix + '1.2.9.content.4')}}</p>
                    <p class="pt-2">{{t(translocoPrefix + '1.2.9.content.5')}}</p>
                </div>


<!--                Izvori osobnih podatka-->
                <div class="ps-2 pt-4">
                    <p class="title">{{t(translocoPrefix + '1.2.10.title')}}</p>
                    <div class="pt-2">
                        <p class="teal fst-italic">{{t(translocoPrefix + '1.2.10.1.title')}}</p>
                        <p class="ps-2">{{t(translocoPrefix + '1.2.10.1.content.1')}}</p>

                        <p class="teal fst-italic">{{t(translocoPrefix + '1.2.10.2.title')}}</p>
                        <p class="ps-2">{{t(translocoPrefix + '1.2.10.2.content.1')}}</p>

                        <p class="teal fst-italic">{{t(translocoPrefix + '1.2.10.3.title')}}</p>
                        <p class="ps-2">{{t(translocoPrefix + '1.2.10.3.content.1')}}</p>
                    </div>
                </div>


<!--                Što ako odlučite ne pružiti osobne podatke?-->
                <div class="ps-2 pt-4">
                    <p class="title">{{t(translocoPrefix + '1.2.11.title')}}</p>
                    <p class="pt-2">{{t(translocoPrefix + '1.2.11.content.1')}}</p>
                    <p class="pt-2">{{t(translocoPrefix + '1.2.11.content.2')}}</p>
                    <p class="pt-2">{{t(translocoPrefix + '1.2.11.content.3')}}</p>
                    <p>{{t(translocoPrefix + '1.2.11.content.4')}}</p>
                </div>
            </div>


            <div>

            </div>


<!--        III. Kategorije primatelja osobnih podataka, prekogranični prijenos:-->
        <div class="sub-chapter">
            <p class="title pt-4">{{t(translocoPrefix + '1.3.title')}}</p>
            <p class="pt-2">{{t(translocoPrefix + '1.3.content.1')}}</p>
            <p class="pt-2">{{t(translocoPrefix + '1.3.content.2')}}</p>
            <p class="pt-2">{{t(translocoPrefix + '1.3.content.3')}}</p>
            <p class="pt-2">{{t(translocoPrefix + '1.3.content.4')}}</p>
            <p class="pt-2">{{t(translocoPrefix + '1.3.content.5')}}</p>
            <ul>
                <li>
                    <p class="pt-2">{{t(translocoPrefix + '1.3.content.6')}}</p>
                </li>
                <li>
                    <p class="pt-2">{{t(translocoPrefix + '1.3.content.7')}}</p>
                </li>
            </ul>
            <p class="pt-2">{{t(translocoPrefix + '1.3.content.8')}}</p>
        </div>


<!--        IV Ostvarivanje prava vezanu uz obradu osobnih podataka-->
        <div class="sub-chapter">
            <p class="title pt-4">{{t(translocoPrefix + '1.4.title')}}</p>
            <p class="pt-2">{{t(translocoPrefix + '1.4.content.1')}}</p>
            <p class="pt-2">{{t(translocoPrefix + '1.4.content.2')}}</p>
            <p class="pt-2">{{t(translocoPrefix + '1.4.content.3')}}</p>
            <p class="pt-2">{{t(translocoPrefix + '1.4.content.4')}}</p>

<!--            1. Pravo na pristup podacima:-->
            <div class="ps-4 pt-4">
                <p class="title fst-italic">{{t(translocoPrefix + '1.4.1.title')}}</p>
                <p>{{t(translocoPrefix + '1.4.1.content.1')}}</p>
                <ul>
                    <li><p>{{t(translocoPrefix + '1.4.1.content.2')}}</p></li>
                    <li><p>{{t(translocoPrefix + '1.4.1.content.3')}}</p></li>
                    <li><p>{{t(translocoPrefix + '1.4.1.content.4')}}</p></li>
                    <li><p>{{t(translocoPrefix + '1.4.1.content.5')}}</p></li>
                    <li><p>{{t(translocoPrefix + '1.4.1.content.6')}}</p></li>
                    <li><p>{{t(translocoPrefix + '1.4.1.content.7')}}</p></li>
                    <li><p>{{t(translocoPrefix + '1.4.1.content.8')}}</p></li>
                    <li><p>{{t(translocoPrefix + '1.4.1.content.9')}}</p></li>
                    <li><p>{{t(translocoPrefix + '1.4.1.content.10')}}</p></li>
                </ul>
            </div>

<!--            2. Pravo na ispravak-->
            <div class="ps-4 pt-4">
                <p class="title fst-italic">{{t(translocoPrefix + '1.4.2.title')}}</p>
                <p>{{t(translocoPrefix + '1.4.2.content.1')}}</p>
            </div>


<!--            3. Pravo brisanja (pravo na zaborav)-->
            <div class="ps-4 pt-4">
                <p class="title fst-italic">{{t(translocoPrefix + '1.4.3.title')}}</p>
                <p>{{t(translocoPrefix + '1.4.3.content.1')}}</p>
                <ul>
                    <li><p>{{t(translocoPrefix + '1.4.3.content.2')}}</p></li>
                    <li><p>{{t(translocoPrefix + '1.4.3.content.3')}}</p></li>
                    <li><p>{{t(translocoPrefix + '1.4.3.content.4')}}</p></li>
                    <li><p>{{t(translocoPrefix + '1.4.3.content.5')}}</p></li>
                    <li><p>{{t(translocoPrefix + '1.4.3.content.6')}}</p></li>
                </ul>
                <p class="pt-3">{{t(translocoPrefix + '1.4.3.content.7')}}</p>
                <ul>
                    <li><p>{{t(translocoPrefix + '1.4.3.content.8')}}</p></li>
                    <li><p>{{t(translocoPrefix + '1.4.3.content.9')}}</p></li>
                    <li><p>{{t(translocoPrefix + '1.4.3.content.10')}}</p></li>
                </ul>
            </div>

<!--                      4. Pravo na povlačenje privole-->
            <div class="ps-4 pt-4">
                <p class="title fst-italic">{{t(translocoPrefix + '1.4.4.title')}}</p>
                <p>{{t(translocoPrefix + '1.4.4.content.1')}}</p>
            </div>


<!--            5. Pravo na ograničenje obrade-->
            <div class="ps-4 pt-4">
                <p class="title fst-italic">{{t(translocoPrefix + '1.4.5.title')}}</p>
                <p>{{t(translocoPrefix + '1.4.5.content.1')}}</p>
                <ul>
                    <li><p>{{t(translocoPrefix + '1.4.5.content.2')}}</p></li>
                    <li><p>{{t(translocoPrefix + '1.4.5.content.3')}}</p></li>
                    <li><p>{{t(translocoPrefix + '1.4.5.content.4')}}</p></li>
                    <li><p>{{t(translocoPrefix + '1.4.5.content.5')}}</p></li>
                </ul>
            </div>

            <!--  6. Pravo na prijenos podatka-->
            <div class="ps-4 pt-4">
                <p class="title fst-italic">{{t(translocoPrefix + '1.4.6.title')}}</p>
                <p>{{t(translocoPrefix + '1.4.6.content.1')}}</p>
            </div>

<!--            7. Pravo na prigovor-->
            <div class="ps-4 pt-4">
                <p class="title fst-italic">{{t(translocoPrefix + '1.4.7.title')}}</p>
                <p>{{t(translocoPrefix + '1.4.7.content.1')}}</p>
                <div class="ps-2 pt-2">
                    <p class="teal fst-italic">{{t(translocoPrefix + '1.4.7.1.title')}}</p>
                    <p>{{t(translocoPrefix + '1.4.7.1.content.1')}}</p>
                </div>
                <p class="pt-2">{{t(translocoPrefix + '1.4.7.1.content.2')}}</p>
            </div>

<!--            8. Pravo podnošenja pritužbe nadležnom tijelu za zaštitu podatka-->
            <div class="ps-4 pt-4">
                <p class="title fst-italic">{{t(translocoPrefix + '1.4.8.title')}}</p>
                <p>{{t(translocoPrefix + '1.4.8.content.1')}}</p>
            </div>
        </div>
        </div>

        <div class="chapter mt-3 pb-3">
<!--            STOTINKA KAO VODITELJ OBRADE-->
            <p class="title">{{t(translocoPrefix + '2.title')}}</p>

            <div class="sub-chapter">
<!--                I. Svrhe, pravne osnove obrade, kategorije osobnih podataka i rok čuvanja-->
                <p class="title pt-4">{{t(translocoPrefix + '2.1.title')}}</p>
<!--                KATEGORIJA ISPITANIKA – SUDIONICI/ REGISTRIRANI ČLANOVI-->
                <div class="ps-4 pt-4">
                    <p class="title fst-italic">{{t(translocoPrefix + '2.1.1.title')}}</p>
                    <div class="pt-3 ps-2">
<!--                        1) Svrha: Obrada u svrhu otvaranja i vođenja profila članova (pružanja usluga članovima)-->
                        <p class="title">{{t(translocoPrefix + '2.1.1.1.title')}}</p>
                        <p>{{t(translocoPrefix + '2.1.1.1.content.1')}}</p>

                        <div class="ps-2 pt-2">
<!--                            Kategorije osobnih podataka-->
                            <p class="teal fw-medium">{{t(translocoPrefix + '2.1.1.1.1.title')}}</p>
                            <p>{{t(translocoPrefix + '2.1.1.1.1.content.1')}}</p>
                            <p>{{t(translocoPrefix + '2.1.1.1.1.content.2')}}</p>
                            <p>{{t(translocoPrefix + '2.1.1.1.1.content.3')}}</p>
                            <p>{{t(translocoPrefix + '2.1.1.1.1.content.4')}}</p>
                        </div>

                        <div class="ps-2 pt-2">
<!--                            Pravna osnova-->
                            <p class="teal fw-medium">{{t(translocoPrefix + '2.1.1.1.2.title')}}</p>
                            <p>{{t(translocoPrefix + '2.1.1.1.2.content.1')}}</p>
                            <p>{{t(translocoPrefix + '2.1.1.1.2.content.2')}}</p>
                            <ul>
                                <li><p class="teal">{{t(translocoPrefix + '2.1.1.1.2.content.3')}}</p></li>
                                <li><p class="teal">{{t(translocoPrefix + '2.1.1.1.2.content.4')}}</p></li>
                                <li><p class="teal">{{t(translocoPrefix + '2.1.1.1.2.content.5')}}</p></li>
                                <li><p class="teal">{{t(translocoPrefix + '2.1.1.1.2.content.6')}}</p></li>
                                <li><p class="teal">{{t(translocoPrefix + '2.1.1.1.2.content.7')}}</p></li>
                            </ul>
                            <p class="pt-1">{{t(translocoPrefix + '2.1.1.1.2.content.8')}}</p>
                        </div>


                        <div class="ps-2 pt-2">
                            <!-- Profiliranje-->
                            <p class="teal fw-medium">{{t(translocoPrefix + '2.1.1.1.3.title')}}</p>
                            <p>{{t(translocoPrefix + '2.1.1.1.3.content.1')}}</p>
                            <p>{{t(translocoPrefix + '2.1.1.1.3.content.2')}}</p>
                            <p>{{t(translocoPrefix + '2.1.1.1.3.content.3')}}</p>
                        </div>

                        <div class="ps-2 pt-2">
                            <!-- Rok čuvanja-->
                            <p class="teal fw-medium">{{t(translocoPrefix + '2.1.1.1.4.title')}}</p>
                            <p>{{t(translocoPrefix + '2.1.1.1.4.content.1')}}</p>
                        </div>
                    </div>

                    <div class="pt-3 ps-2">
                        <!--                        2) Svrha: Obrada Vaših osobnih podataka u svrhu anketiranja-->
                        <p class="title">{{t(translocoPrefix + '2.1.1.2.title')}}</p>
                        <p>{{t(translocoPrefix + '2.1.1.2.content.1')}}</p>

                        <div class="ps-2 pt-2">
                            <!--                            Kategorije osobnih podataka-->
                            <p class="teal fw-medium">{{t(translocoPrefix + '2.1.1.2.1.title')}}</p>
                            <p>{{t(translocoPrefix + '2.1.1.2.1.content.1')}}</p>
                        </div>

                        <div class="ps-2 pt-2">
                            <!--                            Pravna osnova-->
                            <p class="teal fw-medium">{{t(translocoPrefix + '2.1.1.2.2.title')}}</p>
                            <p>{{t(translocoPrefix + '2.1.1.2.2.content.1')}}</p>
                        </div>


                        <div class="ps-2 pt-2">
                            <!-- Rok čuvanja-->
                            <p class="teal fw-medium">{{t(translocoPrefix + '2.1.1.2.3.title')}}</p>
                            <p>{{t(translocoPrefix + '2.1.1.2.3.content.1')}}</p>
                        </div>
                    </div>

                    <div class="pt-3 ps-2">

                        <!--3)  Svrha: Obrada Vaših podataka u svrhu dostavljanja posebnih ponuda-->
                        <p class="title">{{t(translocoPrefix + '2.1.1.3.title')}}</p>
                        <p>{{t(translocoPrefix + '2.1.1.3.content.1')}}</p>

                        <div class="ps-2 pt-2">
                            <!--                            Kategorije osobnih podataka-->
                            <p class="teal fw-medium">{{t(translocoPrefix + '2.1.1.3.1.title')}}</p>
                            <p>{{t(translocoPrefix + '2.1.1.3.1.content.1')}}</p>
                        </div>

                        <div class="ps-2 pt-2">
                            <!--                            Pravna osnova-->
                            <p class="teal fw-medium">{{t(translocoPrefix + '2.1.1.3.2.title')}}</p>
                            <p>{{t(translocoPrefix + '2.1.1.3.2.content.1')}}</p>
                        </div>

                        <div class="ps-2 pt-2">
                            <!-- Rok čuvanja-->
                            <p class="teal fw-medium">{{t(translocoPrefix + '2.1.1.3.3.title')}}</p>
                            <p>{{t(translocoPrefix + '2.1.1.3.3.content.1')}}</p>
                        </div>
                    </div>
                </div>


                <!--                    KATEGORIJA ISPITANIKA – POSJETITELJI NAŠE WEB STRANICE-->
                <div class="ps-4 pt-4">
                    <p class="title fst-italic">{{t(translocoPrefix + '2.1.2.title')}}</p>
                    <div class="pt-3 ps-2">
                        <!--            1) Svrha: Obrada Vaših podataka u svrhu pružanja informacija o našim aktivnostima-->
                        <p class="title">{{t(translocoPrefix + '2.1.2.1.title')}}</p>
                        <p>{{t(translocoPrefix + '2.1.2.1.content.1')}}</p>

                        <div class="ps-2 pt-2">
                            <!--                            Kategorije osobnih podataka-->
                            <p class="teal fw-medium">{{t(translocoPrefix + '2.1.2.1.1.title')}}</p>
                            <p>{{t(translocoPrefix + '2.1.2.1.1.content.1')}}</p>
                        </div>

                        <div class="ps-2 pt-2">
                            <!--  Pravna osnova-->
                            <p class="teal fw-medium">{{t(translocoPrefix + '2.1.2.1.2.title')}}</p>
                            <p>{{t(translocoPrefix + '2.1.2.1.2.content.1')}}</p>
                        </div>

                        <div class="ps-2 pt-2">
                            <!--  Rok čuvanja-->
                            <p class="teal fw-medium">{{t(translocoPrefix + '2.1.2.1.3.title')}}</p>
                            <p>{{t(translocoPrefix + '2.1.2.1.3.content.1')}}</p>
                        </div>
                    </div>

                    <div class="pt-3 ps-2">
<!--                        2) Svrha : Odgovaranje na Vaše upite-->
                        <p class="title">{{t(translocoPrefix + '2.1.2.2.title')}}</p>

                        <div class="ps-2 pt-2">
                            <!--                            Kategorije osobnih podataka-->
                            <p class="teal fw-medium">{{t(translocoPrefix + '2.1.2.2.1.title')}}</p>
                            <p>{{t(translocoPrefix + '2.1.2.2.1.content.1')}}</p>
                        </div>

                        <div class="ps-2 pt-2">
                            <!--  Pravna osnova-->
                            <p class="teal fw-medium">{{t(translocoPrefix + '2.1.2.2.2.title')}}</p>
                            <p>{{t(translocoPrefix + '2.1.2.2.2.content.1')}}</p>
                            <ul>
                                <li><p>{{t(translocoPrefix + '2.1.2.2.2.content.2')}}</p></li>
                                <li><p>{{t(translocoPrefix + '2.1.2.2.2.content.3')}}</p></li>
                                <li><p>{{t(translocoPrefix + '2.1.2.2.2.content.4')}}</p></li>
                            </ul>
                        </div>

                        <div class="ps-2 pt-2">
                            <!--  Rok čuvanja-->
                            <p class="teal fw-medium">{{t(translocoPrefix + '2.1.2.2.3.title')}}</p>
                            <p>{{t(translocoPrefix + '2.1.2.2.3.content.1')}}</p>
                        </div>
                    </div>
                </div>


<!--                KATEGORIJA ISPITANIKA – KANDIDATI ZA PRIMANJE U RADNI ODNOS-->
                <div class="ps-4 pt-4">
                    <p class="title fst-italic">{{t(translocoPrefix + '2.1.3.title')}}</p>
                    <div class="pt-3 ps-2">
                        <div class="ps-2 pt-2">
                            <!--                            Kategorije osobnih podataka-->
                            <p class="teal fw-medium">{{t(translocoPrefix + '2.1.3.1.title')}}</p>
                            <p>{{t(translocoPrefix + '2.1.3.1.content.1')}}</p>
                        </div>

                        <div class="ps-2 pt-2">
                            <!--  Pravna osnova-->
                            <p class="teal fw-medium">{{t(translocoPrefix + '2.1.3.2.title')}}</p>
                            <p>{{t(translocoPrefix + '2.1.3.2.content.1')}}</p>
                            <p class="pt-2">{{t(translocoPrefix + '2.1.3.2.content.2')}}</p>
                        </div>

                        <div class="ps-2 pt-2">
                            <!--  Rok čuvanja-->
                            <p class="teal fw-medium">{{t(translocoPrefix + '2.1.3.3.title')}}</p>
                            <p>{{t(translocoPrefix + '2.1.3.3.content.1')}}</p>
                            <p>{{t(translocoPrefix + '2.1.3.3.content.2')}}</p>
                        </div>
                    </div>
                </div>


<!--                KATEGORIJA ISPITANIKA – POSLOVNI PARTNERI /FIZIČKE OSOBE ILI OBRTNICI-->
                <div class="ps-4 pt-4">
                    <p class="title fst-italic">{{t(translocoPrefix + '2.1.4.title')}}</p>
                    <div class="pt-3 ps-2">
                        <div class="ps-2 pt-2">
                            <!--                            Kategorije osobnih podataka-->
                            <p class="teal fw-medium">{{t(translocoPrefix + '2.1.4.1.title')}}</p>
                            <p>{{t(translocoPrefix + '2.1.4.1.content.1')}}</p>
                            <p class="pt-2">{{t(translocoPrefix + '2.1.4.1.content.2')}}</p>
                            <p class="pt-1">{{t(translocoPrefix + '2.1.4.1.content.3')}}</p>
                        </div>

                        <div class="ps-2 pt-2">
                            <!--  Pravna osnova-->
                            <p class="teal fw-medium">{{t(translocoPrefix + '2.1.4.2.title')}}</p>
                            <p>{{t(translocoPrefix + '2.1.4.2.content.1')}}</p>
                            <p>{{t(translocoPrefix + '2.1.4.2.content.2')}}</p>
                        </div>

                        <div class="ps-2 pt-2">
                            <!--  Rok čuvanja-->
                            <p class="teal fw-medium">{{t(translocoPrefix + '2.1.4.3.title')}}</p>
                            <p>{{t(translocoPrefix + '2.1.4.3.content.1')}}</p>
                        </div>
                    </div>
                </div>

<!--                Izravni marketing*** (u svrhu slanja, pozivnica, newslettera (informacije o projektima, proizvodima i sl.)-->
                <div class="ps-4 pt-4">
                    <p class="title fst-italic">{{t(translocoPrefix + '2.1.5.title')}}</p>
                    <div class="pt-3 ps-2">
                        <div class="ps-2 pt-2">
                            <!--                            Kategorije osobnih podataka-->
                            <p class="teal fw-medium">{{t(translocoPrefix + '2.1.5.1.title')}}</p>
                            <p>{{t(translocoPrefix + '2.1.5.1.content.1')}}</p>
                        </div>

                        <div class="ps-2 pt-2">
                            <!--  Pravna osnova-->
                            <p class="teal fw-medium">{{t(translocoPrefix + '2.1.5.2.title')}}</p>
                            <p>{{t(translocoPrefix + '2.1.5.2.content.1')}}</p>
                        </div>

                        <div class="ps-2 pt-2">
                            <!--  Rok čuvanja-->
                            <p class="teal fw-medium">{{t(translocoPrefix + '2.1.5.3.title')}}</p>
                            <p>{{t(translocoPrefix + '2.1.5.3.content.1')}}</p>
                        </div>
                    </div>
                </div>

<!--                napomene-->
                <div class="ps-2 pt-4">
                    <p class="teal">{{t(translocoPrefix + '2.1.6.title')}}</p>
                    <p class="pt-2">{{t(translocoPrefix + '2.1.6.content.1')}}</p>
                    <p class="pt-2">{{t(translocoPrefix + '2.1.6.content.2')}}</p>
                    <p class="pt-2">{{t(translocoPrefix + '2.1.6.content.3')}}</p>
                    <p class="pt-2">{{t(translocoPrefix + '2.1.6.content.4')}}</p>
                </div>

<!--                Kolačići i obrada IP adrese"-->
                <div class="ps-2 pt-4">
                    <p class="title">{{t(translocoPrefix + '2.1.7.title')}}</p>
                    <p class="pt-2">{{t(translocoPrefix + '2.1.7.content.1')}}</p>
                    <p class="pt-2">{{t(translocoPrefix + '2.1.7.content.2')}}</p>
                    <p class="pt-2">{{t(translocoPrefix + '2.1.7.content.3')}}</p>
                    <p class="pt-2">{{t(translocoPrefix + '2.1.7.content.4')}}</p>

                    <div class="pt-2">
                        <p class="teal fst-italic">{{t(translocoPrefix + '2.1.7.1.title')}}</p>
                        <p class="ps-2">{{t(translocoPrefix + '2.1.7.1.content.1')}}</p>
                    </div>

                    <div class="pt-2">
                        <p class="teal fst-italic">{{t(translocoPrefix + '2.1.7.2.title')}}</p>
                        <p class="ps-2">{{t(translocoPrefix + '2.1.7.2.content.1')}}</p>
                    </div>

                    <div class="pt-2">
                        <p class="teal fst-italic">{{t(translocoPrefix + '2.1.7.3.title')}}</p>
                        <p class="ps-2">{{t(translocoPrefix + '2.1.7.3.content.1')}}</p>
                    </div>

                    <p class="pt-2">{{t(translocoPrefix + '2.1.7.content.5')}}</p>
                    <p class="pt-2">{{t(translocoPrefix + '2.1.7.content.6')}}</p>
                    <p class="pt-2">{{t(translocoPrefix + '2.1.7.content.7')}}</p>
                </div>

<!--                Izvori osobnih podatka-->
                <div class="ps-2 pt-4">
                    <p class="title">{{t(translocoPrefix + '2.1.8.title')}}</p>
                    <div class="pt-2">
                        <p class="teal fst-italic">{{t(translocoPrefix + '2.1.8.content.1')}}</p>
                        <ul>
                            <li><p>{{t(translocoPrefix + '2.1.8.content.2')}}</p></li>
                            <li><p>{{t(translocoPrefix + '2.1.8.content.3')}}</p></li>
                            <li><p>{{t(translocoPrefix + '2.1.8.content.4')}}</p></li>
                            <li><p>{{t(translocoPrefix + '2.1.8.content.5')}}</p></li>
                            <li><p>{{t(translocoPrefix + '2.1.8.content.6')}}</p></li>
                            <li><p>{{t(translocoPrefix + '2.1.8.content.7')}}</p></li>
                        </ul>

                        <p class="teal fst-italic pt-2">{{t(translocoPrefix + '2.1.8.content.8')}}</p>
                        <ul>
                            <li><p>{{t(translocoPrefix + '2.1.8.content.9')}}</p></li>
                            <li><p>{{t(translocoPrefix + '2.1.8.content.10')}}</p></li>
                        </ul>

                        <p class="teal fst-italic pt-2">{{t(translocoPrefix + '2.1.8.content.11')}}</p>
                        <p>{{t(translocoPrefix + '2.1.8.content.12')}}</p>
                        <ul>
                            <li><p>{{t(translocoPrefix + '2.1.8.content.13')}}</p></li>
                            <li><p>{{t(translocoPrefix + '2.1.8.content.14')}}</p></li>
                        </ul>

                    </div>
                </div>

<!--                Što ako odlučite ne pružiti osobne podatke?-->
                <div class="ps-2 pt-4">
                    <p class="title">{{t(translocoPrefix + '2.1.9.title')}}</p>
                    <p class="pt-2">{{t(translocoPrefix + '2.1.9.content.1')}}</p>
                    <p class="pt-2">{{t(translocoPrefix + '2.1.9.content.2')}}</p>
                </div>
            </div>


            <div class="sub-chapter">
<!--                II Tko može primiti Vaše osobne podatke, prekogranični prijenos podataka-->
                <p class="title pt-4">{{t(translocoPrefix + '2.2.title')}}</p>
                <p class="pt-2">{{t(translocoPrefix + '2.2.content.1')}}</p>
                <p class="pt-2">{{t(translocoPrefix + '2.2.content.2')}}</p>
                <p class="pt-2">{{t(translocoPrefix + '2.2.content.3')}}</p>
                <p class="pt-2">{{t(translocoPrefix + '2.2.content.4')}}</p>
                <p class="pt-2">{{t(translocoPrefix + '2.2.content.5')}}</p>
                <p class="pt-2">{{t(translocoPrefix + '2.2.content.6')}}</p>
                <ul>
                    <li><p class="pt-2">{{t(translocoPrefix + '2.2.content.7')}}</p></li>
                    <li><p class="pt-2">{{t(translocoPrefix + '2.2.content.8')}}</p></li>
                </ul>
                <p class="pt-2">{{t(translocoPrefix + '2.2.content.9')}}</p>
                <p class="pt-2">{{t(translocoPrefix + '2.2.content.10')}}</p>
            </div>

            <div class="sub-chapter">
<!--                III Sigurnost pohrane-->
                <p class="title pt-4">{{t(translocoPrefix + '2.3.title')}}</p>
                <p class="pt-2">{{t(translocoPrefix + '2.3.content.1')}}</p>
                <p class="pt-2">{{t(translocoPrefix + '2.3.content.2')}}</p>
                <p class="pt-2">{{t(translocoPrefix + '2.3.content.3')}}</p>
                <p class="pt-2">{{t(translocoPrefix + '2.3.content.4')}}</p>
                <div class="pt-2 ps-2">
                        <p class="title">{{t(translocoPrefix + '2.3.1.title')}}</p>
                        <p class="ps-2">{{t(translocoPrefix + '2.3.1.content.1')}}</p>
                </div>
            </div>


            <div class="sub-chapter">
<!--                IV Ostvarivanje prava vezanu uz obradu osobnih podataka-->
                <p class="title pt-4">{{t(translocoPrefix + '2.4.title')}}</p>
                <p class="pt-2">{{t(translocoPrefix + '2.4.content.1')}}</p>
                <p class="pt-2">{{t(translocoPrefix + '2.4.content.1')}}</p>
                <p class="pt-2">{{t(translocoPrefix + '2.4.content.2')}}</p>
                <p class="pt-2">{{t(translocoPrefix + '2.4.content.3')}}</p>
                <p class="pt-2">{{t(translocoPrefix + '2.4.content.4')}}</p>

                <div class="ps-4 pt-3">
<!--                    1. Pravo na pristup podacima:-->
                    <p class="title fst-italic">{{t(translocoPrefix + '2.4.1.title')}}</p>
                    <p class="pt-2">{{t(translocoPrefix + '2.4.1.content.1')}}</p>
                    <ul>
                        <li><p>{{t(translocoPrefix + '2.4.1.content.2')}}</p></li>
                        <li><p>{{t(translocoPrefix + '2.4.1.content.3')}}</p></li>
                        <li><p>{{t(translocoPrefix + '2.4.1.content.4')}}</p></li>
                        <li><p>{{t(translocoPrefix + '2.4.1.content.5')}}</p></li>
                        <li><p>{{t(translocoPrefix + '2.4.1.content.6')}}</p></li>
                        <li><p>{{t(translocoPrefix + '2.4.1.content.7')}}</p></li>
                        <li><p>{{t(translocoPrefix + '2.4.1.content.8')}}</p></li>
                        <li><p>{{t(translocoPrefix + '2.4.1.content.9')}}</p></li>
                        <li><p>{{t(translocoPrefix + '2.4.1.content.10')}}</p></li>
                    </ul>
                </div>

                <div class="ps-4 pt-3">
<!--                    2. Pravo na ispravak-->
                    <p class="title fst-italic">{{t(translocoPrefix + '2.4.2.title')}}</p>
                    <p class="pt-2">{{t(translocoPrefix + '2.4.2.content.1')}}</p>
                </div>

                <div class="ps-4 pt-3">
                    <!-- 3. Pravo brisanja (pravo na zaborav)-->
                    <p class="title fst-italic">{{t(translocoPrefix + '2.4.3.title')}}</p>
                    <p class="pt-2">{{t(translocoPrefix + '2.4.3.content.1')}}</p>
                    <ul>
                        <li><p>{{t(translocoPrefix + '2.4.3.content.3')}}</p></li>
                        <li><p>{{t(translocoPrefix + '2.4.3.content.4')}}</p></li>
                        <li><p>{{t(translocoPrefix + '2.4.3.content.5')}}</p></li>
                        <li><p>{{t(translocoPrefix + '2.4.3.content.6')}}</p></li>
                        <li><p>{{t(translocoPrefix + '2.4.3.content.7')}}</p></li>
                    </ul>

                    <p class="pt-2">{{t(translocoPrefix + '2.4.3.content.8')}}</p>
                    <ul>
                        <li><p>{{t(translocoPrefix + '2.4.3.content.9')}}</p></li>
                        <li><p>{{t(translocoPrefix + '2.4.3.content.10')}}</p></li>
                        <li><p>{{t(translocoPrefix + '2.4.3.content.11')}}</p></li>
                    </ul>
                </div>

                <div class="ps-4 pt-3">
<!--                    4. Pravo na povlačenje privole-->
                    <p class="title fst-italic">{{t(translocoPrefix + '2.4.4.title')}}</p>
                    <p class="pt-2">{{t(translocoPrefix + '2.4.4.content.1')}}</p>
                </div>

                <div class="ps-4 pt-3">
<!--                    5.Pravo na ograničenje obrade-->
                    <p class="title fst-italic">{{t(translocoPrefix + '2.4.5.title')}}</p>
                    <p class="pt-2">{{t(translocoPrefix + '2.4.5.content.1')}}</p>
                    <ul>
                        <li><p>{{t(translocoPrefix + '2.4.5.content.2')}}</p></li>
                        <li><p>{{t(translocoPrefix + '2.4.5.content.3')}}</p></li>
                        <li><p>{{t(translocoPrefix + '2.4.5.content.4')}}</p></li>
                        <li><p>{{t(translocoPrefix + '2.4.5.content.5')}}</p></li>
                    </ul>
                </div>

                <div class="ps-4 pt-3">
<!--                    6. Pravo na prijenos podatka-->
                    <p class="title fst-italic">{{t(translocoPrefix + '2.4.6.title')}}</p>
                    <p class="pt-2">{{t(translocoPrefix + '2.4.6.content.1')}}</p>
                </div>

                <div class="ps-4 pt-3">
<!--                    7. Pravo na prigovor-->
                    <p class="title fst-italic">{{t(translocoPrefix + '2.4.7.title')}}</p>
                    <p class="pt-2">{{t(translocoPrefix + '2.4.7.content.1')}}</p>
                    <div class="ps-2 pt-2">
                        <p class="teal fst-italic">{{t(translocoPrefix + '2.4.7.1.title')}}</p>
                        <p>{{t(translocoPrefix + '2.4.7.1.content.1')}}</p>
                    </div>
                    <p class="pt-2">{{t(translocoPrefix + '2.4.7.content.2')}}</p>
                </div>

                <div class="ps-4 pt-3">
<!--                    8. Pravo podnošenja pritužbe nadležnom tijelu za zaštitu podatka-->
                    <p class="title fst-italic">{{t(translocoPrefix + '2.4.8.title')}}</p>
                    <p class="pt-2">{{t(translocoPrefix + '2.4.8.content.1')}}</p>
                </div>


            </div>
        </div>
    </div>
</ng-container>